import { createContext } from 'react';

import { ToastContextState } from './toast.model';

export const ToastContext = createContext<ToastContextState | undefined>(undefined);
